import type { SVGProps } from 'react';

export const YouTube = ({ className }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className={className}
      fill="none"
      height="15"
      viewBox="0 0 21 15"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 2.83333C20.5 2.83333 21 5 21 7.5C21 10 20.5 12.1667 20.5 12.1667C20.5 12.5 19.6 14.5 18.5 14.5C18.5 14.5 15.5 15 10.5 15C5.5 15 2.5 14.5 2.5 14.5C1.4 14.5 0.5 12.5 0.5 12.1667C0.5 12.1667 0 10 0 7.5C0 5 0.5 2.83333 0.5 2.83333C0.5 2.5 1.4 0.5 2.5 0.5C2.5 0.5 5.5 -1.73031e-08 10.5 0C15.5 1.73031e-08 18.5 0.5 18.5 0.5C19.6 0.5 20.5 2.5 20.5 2.83333ZM14 7.5L8.5 4.685V10.3033L14 7.5Z"
        fill="#A2A9AD"
      />
    </svg>
  );
};
